import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "event-overview",
  ref: "root"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row g-4 g-xl-5 justify-content-center" }
const _hoisted_4 = { class: "event-overview__card io-eq-el" }
const _hoisted_5 = { class: "event-overview__card__content" }
const _hoisted_6 = {
  class: "event-overview__card__title",
  "data-eq-part": "event-title"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "event-overview__card__body" }
const _hoisted_10 = {
  class: "d-inline-block",
  "data-eq-part": "event-table"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt fa-fw" })
], -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock fa-fw" })
], -1)
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fa-fw" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "event-overview__card__spacer" }, null, -1)
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "event-overview__spacer"
}
const _hoisted_23 = { class: "row g-4 g-xl-5 justify-content-center" }
const _hoisted_24 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextSectionHeadline = _resolveComponent("TextSectionHeadline")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SectionSpacerClouds = _resolveComponent("SectionSpacerClouds")!
  const _component_SectionSpacerBar = _resolveComponent("SectionSpacerBar")!

  return (_ctx.events.length || _ctx.pastEvents.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["event-overview__container io-eq", _ctx.containerClasses])
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.events.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_TextSectionHeadline, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Veranstaltungsübersicht ")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-12 col-md-6",
                        key: `event-${event.id}`
                      }, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", {
                                innerHTML: event.title
                              }, null, 8, _hoisted_7),
                              _createElementVNode("div", {
                                innerHTML: event.subtitle
                              }, null, 8, _hoisted_8)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("span", _hoisted_10, [
                                _createElementVNode("table", null, [
                                  (event.date && event.date !== '')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                        _hoisted_12,
                                        _createElementVNode("td", null, _toDisplayString(_ctx.dateFormated(event.date)), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (event.time && event.time !== '')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                                        _hoisted_14,
                                        _createElementVNode("td", null, _toDisplayString(event.time), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.hasLocation(event))
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                                        _hoisted_16,
                                        _createElementVNode("td", null, [
                                          _createTextVNode(_toDisplayString(event.location), 1),
                                          _hoisted_17,
                                          _createTextVNode(" " + _toDisplayString(event.street), 1),
                                          _hoisted_18,
                                          _createTextVNode(" " + _toDisplayString(event.city), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (event.link && event.link !== '')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_19,
                                    _createElementVNode("a", {
                                      href: event.link,
                                      target: "_blank"
                                    }, [
                                      _createTextVNode(_toDisplayString(event.cta) + " ", 1),
                                      _hoisted_21
                                    ], 8, _hoisted_20)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.pastEvents.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.events.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                    : _createCommentVNode("", true),
                  _createVNode(_component_TextSectionHeadline, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Aufzeichnungen vergangener Veranstaltungen ")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pastEvents, (event) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-auto",
                        key: `event-${event.id}`
                      }, [
                        _createVNode(_component_Button, {
                          "margin-top": "none",
                          class: "py-0",
                          href: event.videoUrl,
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("b", {
                              innerHTML: event.ctaVideo || event.cta
                            }, null, 8, _hoisted_24)
                          ]),
                          _: 2
                        }, 1032, ["href"])
                      ]))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (_ctx.spacer === 'clouds')
          ? (_openBlock(), _createBlock(_component_SectionSpacerClouds, {
              key: 0,
              placement: _ctx.spacerCloudsPlacement
            }, null, 8, ["placement"]))
          : _createCommentVNode("", true),
        (_ctx.spacer === 'bar')
          ? (_openBlock(), _createBlock(_component_SectionSpacerBar, {
              key: 1,
              align: _ctx.spacerBarAlign
            }, null, 8, ["align"]))
          : _createCommentVNode("", true)
      ], 512))
    : _createCommentVNode("", true)
}